module.exports = __webpack_public_path__ + "static/img/subway.d4f2b9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/subway.jpg
// module id = ueaz
// module chunks = 1